import { render, staticRenderFns } from "./DiscussTable.vue?vue&type=template&id=060bc625&scoped=true&"
import script from "./discusstable.js?vue&type=script&lang=js&"
export * from "./discusstable.js?vue&type=script&lang=js&"
import style0 from "./DiscussTable.vue?vue&type=style&index=0&id=060bc625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bc625",
  null
  
)

export default component.exports